import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setPageName } from '../reducers/pageSlice';
import { tabSlice } from '../reducers/labellerDashboard/tabs';
import TabFactory from '../components/tabs/TabFactory';

function LabellerDashboard() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageName('Labeller Dashboard'));
  });

  return <TabFactory slice={tabSlice} />;
}

export default LabellerDashboard;
